import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-invoices';

const generateCustomerInvoiceList = async ({
  companyHeadquarterId,
  customerId,
  manualInvoiceNumber,
  manualDate
}) => {
  const method = 'POST';
  let url = `${USE_CASE_URL}?companyHeadquarterId=${companyHeadquarterId}&headquarterCustomerId=${customerId}`;

  if (manualInvoiceNumber) {
    url += `&manualInvoiceNumber=${manualInvoiceNumber}`;
  }

  if (manualDate) {
    url += `&manualDate=${manualDate}`;
  }

  const json = await request({ method, url });
  return json;
};

export default generateCustomerInvoiceList;
